import { render, staticRenderFns } from "./LtkPostLike.vue?vue&type=template&id=00a44d36&scoped=true"
import script from "./LtkPostLike.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkPostLike.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkPostLike.vue?vue&type=style&index=0&id=00a44d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a44d36",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtnLike: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnLike/CBtnLike.vue').default})
